import { useCookies } from "react-cookie"

const useColorCookie = () => {

    const cookieName = "TCC1"
    const [cookie, setCookie, removeCookie] = useCookies([cookieName])

    const createCookie = (obj) => {
        setCookie(cookieName, JSON.stringify(obj), {
            "path": "/",
            // "sameSite": "none",
            // "secure": true,
        })
    }

    const deleteCookie = () => {
        removeCookie(cookieName, { "path": "/" })
    }

    return [cookie[cookieName], createCookie, deleteCookie]
}

export default useColorCookie